import React, { useEffect, useState }  from 'react';
import { useQuery } from "@tanstack/react-query";
import { FieldSkeleton, HouseSkeleton, LocationSkeleton, ServiceSkeleton, TestimonialSkeleton } from './Skeleton';
import { FieldContainer, HouseContainer, LocationContainer, TestimonialContainer } from './Container';
import Slider from 'react-slick';
import config from '../config/slickConf';
import { ServiceApi } from '../services/service.api';
import { ProductApi } from '../services/product.api';
import { TestimonialApi } from '../services/testimonial.api';

const service = ServiceApi();
const product = ProductApi();
const testimonial = TestimonialApi();


// ***************************************************************************************************************
export function ServiceComponent() 
{     
    const fetchServices = async () => {
        try {
            const res = await service.find(3);
            return res.data.data; 
        } catch (err) { 
            throw new Error('Erreur lors de la récupération des utilisateurs : ' + err.message);
        }
    }
    const { isLoading, data, error } = useQuery({  queryKey: ["services"], queryFn: fetchServices });

    return (

        <div className="col-lg-10 mt-5">
          <div className="row justify-content-center">
            <div className="col-lg-12 px-4">
                <h3 className="text-secondary mb-3 display-6" > Des services pensés pour vous </h3>  
                <div className="row">
                  <div className="col-md-8">
                    <p className="text-secondary lead" > De la recherche de biens à la gestion locative, en passant par la vente et le conseil, nous proposons des services adaptés à vos besoins pour vous aider à concrétiser vos ambitions immobilières. </p>
                  </div>
                </div>
            </div>
            <div className="col-lg-12">
              <div className="row py-5 d-flex justify-content-center"> 
              {  
                isLoading ? ( <div className="row"> <ServiceSkeleton value={ 3 } /> </div> ) : (
                data?.map( (item , index) => {
                    return (
                      <div className="col-lg-4 col-md-6 mb-4" key={index}>
                        <div className="shadow-sm rounded-2 d-flex flex-column align-items-center p-4 scale bg-white">
                          <span className="text-secondatry mb-3"> <i className="bi bi-patch-check fs-1"></i> </span>
                          <div className="card-body">
                            <p className="lead bold text-secondary text-center"> { item.title } </p>
                            <p className="lead text-secondary text-center"> { item.description } </p>
                          </div>
                        </div>
                      </div>
                    )
                }))
              }
              {
                error ? ( <div className="col-md-12 mt-3"> <div className="bg-white border rounded-2 p-5 text-secondary lead" > Une erreur est survenue lors du traitement. Veuillez verifier votre connexion </div> </div> ) : null
              }
              {
                ( Array.isArray(data) && data.length === 0 ) ? ( <div className="bg-white border rounded-2 p-5 text-secondary lead"> La liste de propriétés, vide. </div> ) : null
              } 
              </div> 
            </div>
          </div>
        </div>
    )
}

// *******************************************************************************************************************
export function LocationComponent() 
{
    const settings = config();

    const fetchLocalities = async () => {
        try {
            const res = await product.findLocalities();
            return res.data.data; 
        } catch (err) { 
            throw new Error('Erreur lors de la récupération des utilisateurs : ' + err.message);
        }
    }
    const { isLoading, data, error } = useQuery({  queryKey: ["localities"], queryFn: fetchLocalities });
        
    return (

        <div className="col-lg-10 my-5">
          <div className="row mb-3">
            <div className="col-lg-7 col-md-9">
              <div className="d-flex flex-column">
                <h2 className="text-secondary display-6" > Des opportunités immobilières partout où vous etes </h2>
                <p className="text-secondary lead"> Nous opérons dans plusieurs régions garantissant une couverture étendue et des biens adaptés à toutes les préférences : zones urbaines, rurales, littorales ou intermédiaires.</p>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="row mt-4 d-flex justify-content-center">       
                { 
                    isLoading ? ( <div className="row"> <LocationSkeleton value={ 3 } design={"col-md-6 col-lg-4 mb-5"} /> </div> ) : (
                    <div className="slider-container">
                        <Slider {...settings}> 
                            { 
                                data?.map( (item , index) => { return (
                                    <LocationContainer region={ item.region } count={ item.count } index={index} />
                                )}) 
                            }
                        </Slider>
                    </div> ) 
                }  
                {
                    error ? ( <div className="col-md-12 mt-3"> <div className="bg-white border rounded-2 p-5 text-secondary lead my-3" > Une erreur est survenue lors du traitement. Veuillez verifier votre connexion </div> </div> ) : null
                }
                {
                    ( Array.isArray(data) && data.length === 0 ) ? ( <div className="bg-white border rounded-2 p-5 text-secondary lead my-3"> La liste de propriétés, vide. </div> ) : null
                } 
              </div>
            </div>
          </div> 
        </div> 

    )
} 

// ****************************************************************************************************************
export function NearestHousesComponent() { 

    var settings = config()
    const [coords, setCoords] = useState(null);
    const [errCoord, setErrCoord] = useState(false);

    useEffect(() => {
      navigator.geolocation.getCurrentPosition(
        (item) => setCoords({ lat: item.coords.latitude, lon: item.coords.longitude }),
        (err) => setErrCoord(true),
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    }, []);

    const fetchNearest = async () => {
      const { lat, lon } = coords;
      const res = await product.findNearestHouse(lon, lat);
      return res.data.data;
    };

    const { isLoading, data, error } = useQuery({
      queryKey: ['nearestHouses', coords],
      queryFn: fetchNearest,
      enabled: !!coords,
    });

    return (

        <div className="col-lg-11 py-5"> 
            <div className="row mt-4 d-flex justify-content-center"> 
                { 
                    isLoading ? (  <div className="row"> <HouseSkeleton value={ 3 } design={"col-md-6 col-lg-4 mb-5"} />  </div>  ) : (
                    <div className="slider-container">
                        <Slider {...settings}> 
                            { 
                                data?.map( (item , index) => { return (
                                    <HouseContainer key={index} data={item} />
                                )}) 
                            }
                        </Slider>
                    </div> ) 
                } 
                {
                    errCoord ? ( <div className="bg-white border rounded-2 p-5 text-secondary lead"> Veuillez autoriser la géolocalisation pour avoir la liste de nos logements qui vous sont proche. </div> ) : null
                } 
                {
                    error ? ( <div className="col-md-12 mt-3"> <div className="bg-white border rounded-2 p-5 text-secondary lead" > Une erreur est survenue lors du traitement. Veuillez verifier votre connexion </div> </div> ) : null
                }
                {
                    ( Array.isArray(data) && data.length === 0 ) ? ( <div className="bg-white border rounded-2 p-5 text-secondary lead"> La liste de propriétés, vide. </div> ) : null
                }  
            </div> 
        </div> 
    )
}

// // ****************************************************************************************************************
export function HouseComponent() { 

    var settings = config()

    const fetchHouses = async () => { 
        try {
            const res = await product.findHouse(10);
            return res.data.data; 
        } catch (err) { 
            throw new Error('Erreur lors de la récupération des utilisateurs : ' + err.message);
        }
    }
    const { isLoading, data, error } = useQuery({  queryKey: ["houses"], queryFn: fetchHouses });

    return (

        <div className="col-lg-10 mt-5">
          <div className="row justify-content-center">
            <div className="col-lg-7 col-md-9 mb-4">
              <div className="d-flex flex-column align-items-center">
                <h2 className="text-secondary text-center display-6 mb-2" > Découvrez nos logements </h2>
                <p className="text-secondary text-center lead" > Parcourez nos différentes catégories de biens : maisons familiales, appartements modernes, studios pratiques, et bien plus encore. Il y en a pour tous les budgets et toutes les envies. </p>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="row mt-4 d-flex justify-content-center"> 
                { 
                    isLoading ? (  <div className="row"> <HouseSkeleton value={ 3 } design={"col-md-6 col-lg-4 mb-5"} />  </div>  ) : (
                    <div className="slider-container">
                        <Slider {...settings}> 
                            { 
                                data?.map( (item , index) => { return (
                                    <div className="px-3">
                                      <HouseContainer key={index} data={item} />
                                    </div>
                                )}) 
                            }
                        </Slider>
                    </div> ) 
                }  
                {
                    error ? ( <div className="col-md-12"> <div className="bg-white border rounded-2 p-5 text-secondary lead mb-3" > Une erreur est survenue lors du traitement. Veuillez verifier votre connexion </div> </div> ) : null
                }
                {
                    ( Array.isArray(data) && data.length === 0 ) ? ( <div className="bg-white border rounded-2 p-5 text-secondary lead mb-3"> La liste de propriétés, vide. </div> ) : null
                }  
              </div> 
            </div> 
          </div> 
        </div> 
    )
}

// ****************************************************************************************************************
export function NearestFieldsComponent() { 

    var settings = config();
    const [coords, setCoords] = useState(null);
    const [errCoord, setErrCoord] = useState(false);

    useEffect(() => {
      navigator.geolocation.getCurrentPosition(
          (item) => setCoords({ lat: item.coords.latitude, lon: item.coords.longitude }),
          (err) => setErrCoord(true),
          {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0,
          }
      );
    }, []);

    const fetchFields = async () => {
      const { lat, lon } = coords;
      const res = await product.findNearestField(lon, lat);
      return res.data.data;
    };

    const { isLoading, data, error } = useQuery({
      queryKey: ['nearestFiedls', coords],
      queryFn: fetchFields,
      enabled: !!coords,
    });

    return (

        <div className="col-lg-11 py-5"> 
            <div className="row mt-4 d-flex justify-content-center"> 
                { 
                    isLoading ? (  <div className="row"> <FieldSkeleton value={ 3 } design={"col-md-6 col-lg-4 mb-5"} />  </div>  ) : (
                    <div className="slider-container">
                        <Slider {...settings}> 
                            { 
                                data?.map( (item , index) => { return (
                                    <FieldContainer data={item} key={index} />
                                )}) 
                            }
                        </Slider>
                    </div> ) 
                } 
                {
                    errCoord ? ( <div className="bg-white border rounded-2 p-5 text-secondary lead"> Veuillez autoriser la géolocalisation pour avoir la liste de nos terrains qui vous sont proche. </div> ) : null
                } 
                {
                    error ? ( <div className="col-md-12 mt-3"> <div className="bg-white border rounded-2 p-5 text-secondary lead" > Une erreur est survenue lors du traitement. Veuillez verifier votre connexion </div> </div> ) : null
                }
                {
                    ( Array.isArray(data) && data.length === 0 ) ? ( <div className="bg-white border rounded-2 p-5 text-secondary lead"> La liste de propriétés, vide. </div> ) : null
                }   
            </div> 
        </div> 
    )
}

// ****************************************************************************************************************
export function FieldComponent() { 

    var settings = config()

    const fetchFields = async () => { 
        try {
            const res = await product.findField(10);
            return res.data.data;  
        } catch (err) { 
            throw new Error('Erreur lors de la récupération des utilisateurs : ' + err.message);
        }
    }
    const { isLoading, data, error } = useQuery({  queryKey: ["fields"], queryFn: fetchFields });

    return (

        <div className="col-lg-10 mt-5">
          <div className="row justify-content-center">
            <div className="col-lg-7 col-md-9">
              <div className="d-flex flex-column align-items-center mb-3">
                <h3 className="text-secondary text-center display-6 mb-2" > Découvrez Nos terrains </h3>
                <p className="text-secondary text-center lead" > Parcourez notre sélection de terrains adaptés à tous vos projets : construction, investissement ou aménagement. Des opportunités situées dans des zones stratégiques et en pleine croissance. </p>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="row mt-4 d-flex justify-content-center"> 
                { 
                    isLoading ? ( <div className="row"> <FieldSkeleton value={ 3 } design={"col-md-6 col-lg-4 mb-5"} />  </div> ) : (
                    <div className="slider-container">
                        <Slider {...settings}> 
                            { 
                                data?.map( (item , index) => { return (
                                    <div className="px-3">  
                                      <FieldContainer data={item} key={index} />  
                                    </div>
                                )}) 
                            }
                        </Slider>
                    </div> ) 
                } 
                {
                    error ? ( <div className="col-md-12 mt-3"> <div className="bg-white border rounded-2 p-5 text-secondary lead"> Une erreur est survenue lors du traitement. Veuillez verifier votre connexion </div> </div> ) : null
                }
                {
                    ( Array.isArray(data) && data.length === 0 ) ? ( <div className="bg-white border rounded-2 p-5 text-secondary lead"> La liste de propriétés, vide. </div> ) : null
                }  
              </div> 
            </div>
          </div>  
        </div> 
    )
}

// ****************************************************************************************************************
export function TestimonialComponent() { 

    var settings = config()

    const fetchTestimonials = async () => { 
        try {
            const res = await testimonial.find(6);
            return res.data.data; 
        } catch (err) { 
            throw new Error('Erreur lors de la récupération des utilisateurs : ' + err.message);
        }
    }
    const { isLoading, data, error } = useQuery({ queryKey: ["testimonials"], queryFn: fetchTestimonials });

    return (

        <div className="col-lg-10 mt-5">
          <div className="row justify-content-center">
            <div className="col-lg-5 col-md-8">
              <div className="d-flex flex-column align-items-center border p-3 bg-gray-light rounded-4 mb-3">
                <span className="text-secondary lead text-center" > Les expériences et avis authentiques de nos clients </span>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="row mt-4 mb-5 d-flex justify-content-center px-3"> 
                { 
                    isLoading ? ( <div className="row">  <TestimonialSkeleton value={ 4 } /> </div> ) : (
                    <div className="slider-container">
                        <Slider {...settings}> 
                            { 
                                data?.map( (item , index) => { return (
                                    <TestimonialContainer key={index} title={ item.title } desc={ item.text } /> 
                                )}) 
                            }
                        </Slider>
                    </div> ) 
                }  
                {
                    error ? ( <div className="col-md-12 mt-3"> <div className="bg-white border rounded-2 p-5 text-secondary lead" > Une erreur est survenue lors du traitement. Veuillez verifier votre connexion </div> </div> ) : null
                }
                {
                    ( Array.isArray(data) && data.length === 0 ) ? ( <div className="bg-white border rounded-2 p-5 text-secondary lead"> La liste de propriétés, vide. </div> ) : null
                } 
              </div> 
            </div>
          </div>  
        </div> 
    )
}


// ****************************************************************************************************************

// ****************************************************************************************************************

// ****************************************************************************************************************

// ****************************************************************************************************************
export function SectionTitle({text}) 
{
    return (
        
        <div className="row py-3 d-flex justify-content-center"> 
            <div className="col-md-6 text-center"> 
                <div className="px-5 py-3 w-100 text-center text-muted border bg-three-clr rounded-5"> { text } </div>
            </div> 
        </div>
    )  
}

// ***************************************************************************************************************      
export function SubTitle({text}) 
{             
    return (
        
        <div className="row py-3 d-flex justify-content-center"> 
            <div className="col-md-5 text-center"> 
                <span className="h1 bold text-center text-clr"> { text }  </span>
            </div> 
        </div>
    )
}

// ******************************************************************************************************************
export function TextReducer({text, maxsize}) 
{
    if ( text?.length <= maxsize ) return ( <span > { text }  </span> )
    else{
        const reducer = text?.slice(0, maxsize) + '...';
        return ( <span > { reducer }  </span> )
    }
}

// ****************************************************************************************************************


export function TextExpandable ({ text, wordLimit, isExpanded }) 
{

  const words = text.split(' ');
  const isTooLong = words.length > wordLimit;

  const displayText = isTooLong && !isExpanded
    ? words.slice(0, wordLimit).join(' ') + '...'
    : text;

  return (
    
    <p className='text-secondary mb-2'>
        {displayText}
    </p>

  );

};